/* SERVAL CLUB custom sections. Plain JS, no libraries. Each part initialises on its own root,
   so sections work when the theme editor re-renders them. */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function json(root, sel) { var el = $(sel || 'script[type="application/json"]', root); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  var STAR = '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M10 1.5l2.6 5.6 6.1.7-4.5 4.2 1.2 6L10 15l-5.4 3 1.2-6L1.3 7.8l6.1-.7z"/></svg>';

  /* ---------- countdowns to real end dates ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(ms, short) {
    var s = Math.floor(ms / 1000), d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600; var m = Math.floor(s / 60); s -= m * 60;
    return d + 'd ' + pad(h) + 'h ' + pad(m) + 'm' + (short ? '' : ' ' + pad(s) + 's');
  }
  function tick() {
    var now = Date.now();
    $$('[data-sv-cd]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-sv-cd')), left = end - now;
      if (isNaN(end)) return;
      if (left <= 0) { var host = el.closest('[data-sv-cd-host]'); if (host) host.hidden = true; el.textContent = 'ended'; return; }
      el.textContent = fmt(left, el.hasAttribute('data-short'));
    });
    $$('[data-sv-days]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-sv-days')), days = Math.ceil((end - now) / 864e5);
      if (isNaN(end)) return;
      if (days < 1) { var host = el.closest('[data-sv-cd-host]'); if (host) host.hidden = true; return; }
      el.textContent = days > 1 ? days + ' days left' : 'last day';
    });
  }

  /* ---------- 3D wordmark and ball rally ---------- */
  function initPlaque(root) {
    var w = $('.sv-word3d', root); if (!w || w.dataset.ready) return; w.dataset.ready = '1';
    var word = $('.face', w).textContent, LAYERS = 18;
    function mix(a, b, t) { return Math.round(a + (b - a) * t); }
    for (var i = LAYERS; i >= 1; i--) {
      var s = document.createElement('span'); s.className = 'layer'; s.textContent = word; s.setAttribute('aria-hidden', 'true');
      var t = (i - 1) / (LAYERS - 1);
      s.style.setProperty('--i', i);
      s.style.color = 'rgb(' + mix(184, 40, t) + ',' + mix(151, 32, t) + ',' + mix(90, 20, t) + ')';
      w.insertBefore(s, w.firstChild);
    }
    var HY = 40, F = 766, H = 12, Z0 = 30, CX = 500;
    function P(X, t, y) { var z = Z0 + t; return [CX + F * X / z, HY + F * (H - y) / z, z]; }
    var court = $('.sv-court', root), ball = $('.ball', root), shadow = $('.bshadow', root), trail = $('.trail', root), hist = [], shot = null;
    function newShot(fromFar, startX) {
      var land = fromFar ? 8 + Math.random() * 14 : 56 + Math.random() * 14;
      return { a: [startX, fromFar ? 74 : 4], b: [(Math.random() - .5) * 22, land], c: [(Math.random() - .5) * 20, fromFar ? 2 : 76], start: performance.now(), far: fromFar };
    }
    function ballAt(now) {
      if (!shot) shot = newShot(false, 4);
      var T1 = 1150, T2 = 520, e = now - shot.start, X, tt, y, k;
      if (e < T1) { k = e / T1; X = shot.a[0] + (shot.b[0] - shot.a[0]) * k; tt = shot.a[1] + (shot.b[1] - shot.a[1]) * k; y = 3 * (1 - k) + 24 * k * (1 - k); }
      else if (e < T1 + T2) { k = (e - T1) / T2; X = shot.b[0] + (shot.c[0] - shot.b[0]) * k; tt = shot.b[1] + (shot.c[1] - shot.b[1]) * k; y = 3 * k + 5 * k * (1 - k); }
      else { shot = newShot(!shot.far, shot.c[0]); hist = []; return ballAt(now); }
      return [X, tt, Math.max(0, y)];
    }
    function drawBall(now) {
      if (!ball) return;
      var b = ballAt(now), p = P(b[0], b[1], b[2]), g = P(b[0], b[1], 0), r = Math.max(1.6, .45 * F / p[2]);
      ball.setAttribute('cx', p[0].toFixed(1)); ball.setAttribute('cy', p[1].toFixed(1)); ball.setAttribute('r', r.toFixed(2));
      shadow.setAttribute('cx', g[0].toFixed(1)); shadow.setAttribute('cy', g[1].toFixed(1));
      shadow.setAttribute('rx', (r * 1.2).toFixed(2)); shadow.setAttribute('ry', (r * .4).toFixed(2));
      shadow.style.opacity = Math.max(.15, 1 - b[2] / 12).toFixed(2);
      hist.push(p[0].toFixed(1) + ' ' + p[1].toFixed(1)); if (hist.length > 26) hist.shift();
      trail.setAttribute('d', 'M' + hist.join('L'));
    }
    var px = 0, py = 0, inView = false, hasPointer = false, raf = 0, t0 = performance.now();
    function frame(now) {
      raf = 0;
      var r = root.getBoundingClientRect(), vh = window.innerHeight;
      var prog = Math.min(1, Math.max(0, (vh - r.top) / (vh * .75))), stand = (1 - prog) * 50, ry, rx;
      if (hasPointer) { ry = px * 24; rx = stand + py * -14; }
      else { var k = (now - t0) / 1000; ry = Math.sin(k * .6) * 16; rx = stand + 8 + Math.sin(k * .45) * 4; }
      w.style.setProperty('--ry', ry.toFixed(2) + 'deg');
      w.style.setProperty('--rx', rx.toFixed(2) + 'deg');
      w.style.setProperty('--mx', (50 + ry * 2.2).toFixed(1) + '%');
      drawBall(now);
      if (inView) raf = requestAnimationFrame(frame);
    }
    if (RM) { shot = { a: [0, 4], b: [4, 58], c: [0, 76], start: performance.now() - 600, far: false }; drawBall(performance.now()); return; }
    if (court) court.classList.add('pre');
    new IntersectionObserver(function (es) {
      inView = es[0].isIntersecting;
      if (inView) { if (court) court.classList.add('go'); if (!raf) raf = requestAnimationFrame(frame); }
    }).observe(root);
    if (FINE) root.addEventListener('pointermove', function (e) {
      hasPointer = true; px = (e.clientX / window.innerWidth) - .5;
      var r = w.getBoundingClientRect(); py = (e.clientY - (r.top + r.height / 2)) / window.innerHeight;
    });
    root.addEventListener('pointerleave', function () { hasPointer = false; t0 = performance.now(); });
  }

  /* ---------- Shop the Court colorway selector ---------- */
  function initShop(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var cfg = json(root) || { colors: [] }, colors = cfg.colors, cur = Math.min(cfg.start || 0, colors.length - 1);
    var imgs = $$('.sv-frame img', root), sw = $('.sv-swatches', root), odo = $('.sv-odo-col', root), nm = $('.sv-cw-name', root), ln = $('.sv-cw-line', root), bar = $('.sv-colorbar', root), btn = $('[data-shop-link]', root);
    colors.forEach(function (c, i) {
      var li = document.createElement('li'), b = document.createElement('button');
      b.className = 'sv-sw'; b.type = 'button'; b.style.setProperty('--c', c.hex);
      b.setAttribute('aria-label', String(i + 1).padStart(2, '0') + ' ' + c.name);
      b.addEventListener('click', function () { if (i !== cur) show(i, !RM); });
      li.appendChild(b); sw.appendChild(li);
    });
    function setName(text, animate) {
      nm.classList.remove('anim'); nm.innerHTML = '';
      text.split('').forEach(function (ch, k) { var e = document.createElement('i'); e.textContent = ch === ' ' ? ' ' : ch; e.style.setProperty('--k', k); nm.appendChild(e); });
      if (animate) { void nm.offsetWidth; nm.classList.add('anim'); }
    }
    function show(i, animate) {
      imgs.forEach(function (im) { im.classList.remove('is-on', 'is-under'); im.style.animation = ''; });
      if (animate && imgs[cur]) imgs[cur].classList.add('is-under');
      if (imgs[i]) { imgs[i].classList.add('is-on'); if (!animate) imgs[i].style.animation = 'none'; }
      odo.style.transform = 'translateY(' + (-i) + 'em)';
      setName(colors[i].name, animate);
      ln.textContent = colors[i].line || '';
      bar.style.setProperty('--sock', colors[i].hex);
      if (animate) { bar.classList.remove('go'); void bar.offsetWidth; bar.classList.add('go'); }
      if (btn) { btn.textContent = 'Shop ' + colors[i].name; btn.href = cfg.url + (cfg.url.indexOf('?') > -1 ? '&' : '?') + 'color=' + i; }
      $$('.sv-sw', sw).forEach(function (b, k) { b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      cur = i;
    }
    if (colors.length) show(cur, false);
  }

  /* ---------- Engineering pinned scroll ---------- */
  function initEng(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var steps = $$('.sv-step', root), imgs = $$('.sv-eng-frame img', root), pins = $$('.sv-pin', root), rail = $('.sv-rail', root), list = $('.sv-steps', root);
    function activate(i) {
      steps.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      imgs.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      pins.forEach(function (s, k) { s.classList.toggle('on', k === i); });
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) activate(steps.indexOf(e.target)); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    steps.forEach(function (s) { io.observe(s); });
    function railUpdate() {
      if (!rail) return;
      var r = list.getBoundingClientRect(), vh = window.innerHeight;
      rail.style.setProperty('--prog', (Math.min(1, Math.max(0, (vh * .5 - r.top) / r.height)) * 100).toFixed(1) + '%');
    }
    window.addEventListener('scroll', function () { requestAnimationFrame(railUpdate); }, { passive: true });
    railUpdate();
  }

  /* ---------- member card ---------- */
  function initCard(root) {
    var card = $('.sv-card', root), stage = $('.sv-card-stage', root); if (!card || card.dataset.ready) return; card.dataset.ready = '1';
    var flipped = false;
    card.addEventListener('click', function () {
      flipped = !flipped; card.style.setProperty('--flip', flipped ? '180deg' : '0deg');
      card.setAttribute('aria-label', flipped ? 'Member card perks. Flip back to the front' : 'Member card. Flip to see the perks');
    });
    if (FINE && !RM) {
      stage.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        card.style.setProperty('--ty', ((x - .5) * 26).toFixed(2) + 'deg');
        card.style.setProperty('--tx', ((.5 - y) * 18).toFixed(2) + 'deg');
        card.style.setProperty('--gx', (x * 100).toFixed(0) + '%');
        card.style.setProperty('--gy', (y * 100).toFixed(0) + '%');
      });
      stage.addEventListener('pointerleave', function () { ['--tx', '--ty', '--gx', '--gy'].forEach(function (p) { card.style.removeProperty(p); }); });
    }
  }

  /* ---------- product page: packs, one color and size per pair, add all to cart ---------- */
  function initProduct(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var cfg = json(root); if (!cfg) return;
    var params = new URLSearchParams(location.search);
    var colors = cfg.colors, variants = cfg.variants, tiers = cfg.tiers;
    var startColor = Math.max(0, Math.min(colors.length - 1, parseInt(params.get('color'), 10) || cfg.startColor || 0));
    var wantPack = parseInt(params.get('pack'), 10);
    var sel = tiers.findIndex(function (t) { return t.n === wantPack; }); if (sel < 0) sel = Math.max(0, tiers.findIndex(function (t) { return t.featured; }));
    var rows = [];
    function find(c, s) { return variants.filter(function (v) { return v.c === c && v.s === s; })[0]; }
    function firstAvailColor(s) { for (var i = 0; i < colors.length; i++) { var v = find(i, s); if (v && v.available) return i; } return 0; }

    /* gallery */
    var track = $('.sv-track', root), slides = $$('.sv-slide', track), counter = $('.sv-counter', root), thumbs = $('.sv-thumbs', root), main = $('.sv-slide img', track);
    slides.forEach(function (s, i) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Photo ' + (i + 1));
      var im = $('img', s); b.innerHTML = '<img src="' + (im.currentSrc || im.src) + '" alt="" loading="lazy">';
      b.addEventListener('click', function () { go(i); });
      thumbs.appendChild(b);
    });
    function idx() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: RM ? 'auto' : 'smooth' }); }
    function sync() { var i = idx(); counter.textContent = (i + 1) + ' / ' + slides.length; $$('button', thumbs).forEach(function (b, k) { b.setAttribute('aria-current', String(k === i)); }); }
    track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
    $('[data-prev]', root).addEventListener('click', function () { go(idx() - 1); });
    $('[data-next]', root).addEventListener('click', function () { go(idx() + 1); });
    sync();
    function setGallery(ci) {
      var c = colors[ci]; if (!c || !c.img) return;
      main.removeAttribute('srcset'); main.src = c.img; main.alt = cfg.title + ' in ' + c.name;
      var t = $('img', thumbs); if (t) t.src = c.img;
      var st = $('.sv-sticky img', root); if (st) st.src = c.img;
      if (idx() !== 0) go(0);
    }

    /* tiers */
    var tierEls = $$('.sv-tier', root), totalEl = $('.sv-total', root), subEl = $('.sv-total-sub', root), addBtn = $('.sv-add', root), err = $('.sv-err', root), shown = tiers[sel].total;
    function countTo(target) {
      if (RM) { totalEl.textContent = money(target); shown = target; return; }
      var from = shown, start = performance.now(), dur = 520;
      (function step(now) {
        var k = Math.min(1, (now - start) / dur), e = 1 - Math.pow(1 - k, 3);
        totalEl.textContent = '$' + ((from + (target - from) * e) / 100).toFixed(2);
        if (k < 1) requestAnimationFrame(step); else { totalEl.textContent = money(target); shown = target; }
      })(start);
    }
    function renderRows() {
      var n = tiers[sel].n, box = $('.sv-pairs', root);
      while (rows.length < n) rows.push({ c: rows.length ? rows[rows.length - 1].c : startColor, s: rows.length ? rows[rows.length - 1].s : cfg.defaultSize });
      var html = '';
      for (var i = 0; i < n; i++) {
        html += '<div class="sv-prow" data-r="' + i + '"><b>' + (n > 1 ? 'Pair ' + (i + 1) : 'Color') + '</b><div class="sv-dots" role="radiogroup" aria-label="Pair ' + (i + 1) + ' color">';
        colors.forEach(function (c, k) {
          var v = find(k, rows[i].s), off = !v || !v.available;
          html += '<button type="button" class="sv-dot" role="radio" style="--c:' + c.hex + '" aria-label="' + c.name + (off ? ', sold out' : '') + '" aria-checked="' + (rows[i].c === k) + '" data-c="' + k + '"' + (off ? ' disabled' : '') + '></button>';
        });
        html += '</div>';
        if (cfg.sizes.length > 1) {
          html += '<div class="sv-size" role="radiogroup" aria-label="Pair ' + (i + 1) + ' size">';
          cfg.sizes.forEach(function (s) { html += '<button type="button" role="radio" data-s="' + s + '" aria-checked="' + (rows[i].s === s) + '">' + s + '</button>'; });
          html += '</div>';
        }
        html += '</div>';
      }
      box.innerHTML = html;
    }
    function apply(fromUser) {
      var t = tiers[sel];
      tierEls.forEach(function (b, k) { b.setAttribute('aria-checked', String(k === sel)); });
      if (fromUser) countTo(t.total); else { totalEl.textContent = money(t.total); shown = t.total; }
      subEl.textContent = t.sub;
      var label = (t.n === 1 ? 'Add 1 pair' : 'Add ' + t.n + ' pairs') + ' · ' + money(t.total);
      $('span', addBtn).textContent = label;
      var sb = $('.sv-sticky .sv-btn span', root); if (sb) sb.textContent = 'Add · ' + money(t.total);
      var sn = $('.sv-sticky strong', root); if (sn) sn.textContent = cfg.title + ' · ' + t.n + (t.n > 1 ? ' pairs' : ' pair');
      renderRows();
    }
    tierEls.forEach(function (b, k) { b.addEventListener('click', function () { sel = k; apply(true); }); });
    root.addEventListener('click', function (e) {
      var row = e.target.closest('.sv-prow'); if (!row) return;
      var r = +row.dataset.r, d = e.target.closest('.sv-dot'), s = e.target.closest('.sv-size button');
      if (d && !d.disabled) { rows[r].c = +d.dataset.c; $$('.sv-dot', row).forEach(function (x) { x.setAttribute('aria-checked', String(x === d)); }); if (r === 0) setGallery(rows[0].c); }
      if (s) {
        rows[r].s = s.dataset.s;
        var v = find(rows[r].c, rows[r].s); if (!v || !v.available) rows[r].c = firstAvailColor(rows[r].s);
        renderRows();
      }
    });

    /* add to cart */
    addBtn.addEventListener('click', function () {
      var t = tiers[sel], map = {}, items = [];
      for (var i = 0; i < t.n; i++) {
        var v = find(rows[i].c, rows[i].s);
        if (!v || !v.available) { err.hidden = false; err.textContent = 'Pair ' + (i + 1) + ': that color and size is sold out. Pick another.'; return; }
        map[v.id] = (map[v.id] || 0) + 1;
      }
      Object.keys(map).forEach(function (id) { items.push({ id: +id, quantity: map[id] }); });
      $$('[data-addon]:checked', root).forEach(function (cb) { items.push({ id: +cb.value, quantity: 1 }); });
      err.hidden = true; addBtn.setAttribute('aria-busy', 'true');
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart.');
          location.href = cfg.cartUrl;
        })
        .catch(function (e) { addBtn.removeAttribute('aria-busy'); err.hidden = false; err.textContent = e.message + ' Please try again.'; });
    });

    /* sticky bar once the main button scrolls away */
    var sticky = $('.sv-sticky', root);
    if (sticky) {
      new IntersectionObserver(function (es) {
        var e = es[0], past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('show', past); sticky.setAttribute('aria-hidden', String(!past));
        $('.sv-btn', sticky).tabIndex = past ? 0 : -1;
      }).observe(addBtn);
      $('.sv-btn', sticky).addEventListener('click', function () { addBtn.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' }); setTimeout(function () { addBtn.click(); }, RM ? 0 : 450); });
    }

    rows.push({ c: startColor, s: cfg.defaultSize });
    var v0 = find(startColor, cfg.defaultSize); if (!v0 || !v0.available) rows[0].c = firstAvailColor(cfg.defaultSize);
    setGallery(rows[0].c);
    apply(false);
  }

  /* ---------- cart nudge: reads the real cart, sits above the cart totals ---------- */
  var SOCKS = ['court-crew-sock', 'court-low-sock'];
  function nudgeHTML(cart) {
    var n = 0;
    cart.items.forEach(function (it) { if (SOCKS.indexOf(it.handle) > -1) n += it.quantity; });
    if (!n) return '';
    var msg;
    if (n === 1) msg = 'Add <strong>2 more pairs</strong> and the third is free. Shipping turns free at 3.';
    else if (n === 2) msg = 'Add <strong>1 more pair: it’s free</strong>, and shipping turns free. Your order gets cheaper.';
    else if (n < 6) msg = 'Add <strong>' + (6 - n) + ' more</strong> for $15 a pair and 2 free overgrips.';
    else msg = '<strong>Club Pack unlocked:</strong> $15 a pair. Your 2 free overgrips are added before we ship.';
    var pct = Math.min(100, n / 6 * 100);
    return msg + '<div class="m"><i style="width:' + pct + '%"></i></div><div class="k"><span>' + n + ' pair' + (n > 1 ? 's' : '') + '</span><span>3 = free pair</span><span>6 = $15/pair</span></div>';
  }
  var nudgeTimer = 0;
  function refreshNudges() {
    clearTimeout(nudgeTimer);
    nudgeTimer = setTimeout(function () {
      var totals = $$('.cart-totals');
      totals.forEach(function (t) {
        if (!(t.previousElementSibling && t.previousElementSibling.tagName === 'SERVAL-NUDGE')) t.parentNode.insertBefore(document.createElement('serval-nudge'), t);
      });
      if (!totals.length) return;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { var h = nudgeHTML(cart); $$('serval-nudge').forEach(function (el) { if (el.innerHTML !== h) el.innerHTML = h; }); })
        .catch(function () {});
    }, 200);
  }
  function watchCart() {
    refreshNudges();
    new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var t = recs[i].target;
        if (t.closest && t.closest('serval-nudge')) continue;
        var added = [].slice.call(recs[i].addedNodes);
        if (added.length && added.every(function (n) { return n.tagName === 'SERVAL-NUDGE'; })) continue;
        if ((t.closest && t.closest('.cart-items-component, cart-drawer-component, .cart-totals')) || added.some(function (n) { return n.querySelector && n.querySelector('.cart-totals'); })) { refreshNudges(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('cart:update', refreshNudges);
  }

  function init(scope) {
    $$('[data-sv-plaque]', scope).forEach(initPlaque);
    $$('[data-sv-shop]', scope).forEach(initShop);
    $$('[data-sv-eng]', scope).forEach(initEng);
    $$('[data-sv-club]', scope).forEach(initCard);
    $$('[data-sv-product]', scope).forEach(initProduct);
  }
  function boot() { init(document); tick(); setInterval(tick, 1000); watchCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); tick(); });
  window.SERVAL = { STAR: STAR };
})();
